import {
  SiteMenuElement,
  SiteMenuElementIcon,
  SiteMenuElementWrapper,
} from "./styles";
import chevronDown from "../../../assets/images/icons/chevron-down.svg";
import SubMenu from "../SubMenu";
import { isMobile } from "react-device-detect";
import { useHistory } from "react-router-dom";
import React, { useState } from "react";
import PropTypes from "prop-types";

export default function NavItem(props) {
  const history = useHistory();

  const [displaySubNav, setDisplaySubNav] = useState(false);

  function toggleDisplayNav() {
    setDisplaySubNav(!displaySubNav);
  }

  function showSubNav() {
    if (!isMobile) {
      setDisplaySubNav(true);
    }
  }

  function hideSubNav() {
    setDisplaySubNav(false);
  }

  function handleTopLevelNavClicked() {
    if (isMobile) {
      if (props.menuLink.subNav.length > 0 || props.menuLink.wide) {
        toggleDisplayNav();
      } else {
        history.push(props.menuLink.url);
      }
    } else {
      hideSubNav();
      history.push(props.menuLink.url);
    }
  }

  return (
    <SiteMenuElementWrapper onMouseEnter={showSubNav} onMouseLeave={hideSubNav}>
      <SiteMenuElement onClick={handleTopLevelNavClicked} open={displaySubNav}>
        {props.menuLink.title}
        {props.menuLink.subNav.length > 0 || props.menuLink.wide ? (
          <SiteMenuElementIcon src={chevronDown} active={displaySubNav} />
        ) : null}
      </SiteMenuElement>
      {props.menuLink.subNav.length > 0 || props.menuLink.wide ? (
        <SubMenu
          display={displaySubNav}
          wide={props.menuLink.wide}
          subNavLinks={props.menuLink.subNav}
        />
      ) : null}
    </SiteMenuElementWrapper>
  );
}

NavItem.propTypes = {
  menuLink: PropTypes.object.isRequired,
};
